import FrontSonda from '@gcloud-npm/utils.monitoring.front-sonda';
import { ENVIRONMENTS } from '../../utils/adabyronThirdConstants';

const getThirdPartyHost = (host: any, thirdKey: string) => {
  let thirdPartyHost = '';
  if (thirdKey && ENVIRONMENTS[thirdKey]) {
    const { PRE, PROD } = ENVIRONMENTS[thirdKey];
    thirdPartyHost = PRE;
    if (
      !host.includes('movistar.es.cert') &&
      !host.includes('movistar.es.inte') &&
      host.includes('movistar.es')
    ) {
      thirdPartyHost = PROD;
    }
  }
  return thirdPartyHost;
};

export const getThirdPartyEndPoint = (
  context: any,
  path: string,
  thirdKey: string,
) => {
  try {
    const { environment } = context;
    const { host } = environment;
    const thirdPartyHost = getThirdPartyHost(host, thirdKey);
    const finalEndpoint = `${thirdPartyHost}${path}/`;
    return finalEndpoint;
  } catch (error) {
    console.error(error);
    const frontSonda = new FrontSonda({
      processName: 'getThirdPartyEndPoint',
      context,
      filePath: 'utils/ada-byron-third-utils',
    } as any);
    frontSonda.errorMessage({ info: `error on path ${path}`, error });
  }
  return null;
};
